import { API_AUTH } from "./common";

const QuanLyChoVayApi = {
  lanThanhToan: ({ choVayId, pageIndex, pageSize, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lan-dong-lai?id=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  lanThanhToan1: (choVayId, pageIndex, pageSize, dbName) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lan-dong-lai?id=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  layTrangLanThanhToan: (choVayId, pageSize) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lay-trang-lan-dong-lai?id=${choVayId}&pageSize=${pageSize}`,
      {}
    ),
  laiDenNgay: ({ choVayId, toDate }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lai-den-ngay?id=${choVayId}&toDate=${toDate}`,
      {}
    ),
  laiDenKy: ({ choVayId, toDate }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lai-den-ky?id=${choVayId}&toDate=${toDate}`,
      {}
    ),
  phiPhatTraCham: ({ choVayId, toDate }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-phat-tra-cham?id=${choVayId}&toDate=${toDate}`,
      {}
    ),
  detail: (choVayId) =>
    API_AUTH.get("quan-ly-cho-vay/chi-tiet?id=" + choVayId, {}),
  lichSuGiaHan: ({ choVayId, pageIndex, pageSize, dbName }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-gia-han?chovayId=${choVayId}&pageIndex=${pageIndex}&pageSize=${pageSize}&dbName=${dbName || ''}`,
      {}
    ),
  giaHan: ({ choVayId, count, note }) =>
    API_AUTH.post(`quan-ly-cho-vay/luu-gia-han`, {
      ChoVayId: choVayId,
      SoLanGiaHan: count,
      GhiChu: note,
    }),
  lichSuTraBotGoc: ({ choVayId }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-tra-bot-goc?chovayId=${choVayId}`,
      {}
    ),
  traBotGoc: ({
    choVayId,
    TenKhachHang,
    NgayThucHien,
    SoTien,
    PhiKhac,
    LaiSuatMoi,
    GhiChu,
  }) =>
    API_AUTH.post(`quan-ly-cho-vay/luu-tra-bot-goc`, {
      ChoVayId: choVayId,
      TenNguoiTra: TenKhachHang,
      NgayTraBotGoc: NgayThucHien,
      TienTraGoc: SoTien,
      PhiKhac: PhiKhac,
      LaiSuat: LaiSuatMoi,
      GhiChu: GhiChu,
    }),
  deleteTraBotGoc: ({ choVayId, thuchiId }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/xoa-tra-bot-goc?chovayId=${choVayId}&thuchiId=${thuchiId}`,
      {}
    ),
  lichSuVayThem: ({ choVayId }) =>
    API_AUTH.get(`quan-ly-cho-vay/lich-su-vay-them?chovayId=${choVayId}`, {}),

  lichSuDoiKyThanhToan: ({ choVayId }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-thay-doi-ky-thanh-toan?chovayId=${choVayId}`,
      {}
    ),

  resetLaiKyThanhToan: ({ choVayId }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/reset-ky-thanh-toan?chovayId=${choVayId}`,
      {}
    ),

  vayThem: ({
    choVayId,
    TenKhachHang,
    NgayThucHien,
    SoTien,
    PhiKhac,
    LaiSuatMoi,
    GhiChu,
  }) =>
    API_AUTH.post(`quan-ly-cho-vay/luu-vay-them`, {
      ChoVayId: choVayId,
      TenNguoiVay: TenKhachHang,
      NgayVayThem: NgayThucHien,
      TienVayThem: SoTien,
      PhiKhac: PhiKhac,
      LaiSuat: LaiSuatMoi,
      GhiChu: GhiChu,
    }),
  thayDoiLaiSuat: ({
    choVayId,
    TenKhachHang,
    NgayThucHien,
    LaiSuatMoi,
    GhiChu,
  }) =>
    API_AUTH.post(`quan-ly-cho-vay/thay-doi-ky-lai`, {
      ChoVayId: choVayId,
      TenKhachHang: TenKhachHang,
      NgayThucHien: NgayThucHien,
      LaiSuat: LaiSuatMoi,
      GhiChu: GhiChu,
    }),

  thayDoiKyThanhToan: ({ choVayId, NgayThucHien, CountTypePaid, GhiChu }) =>
    API_AUTH.post(`quan-ly-cho-vay/thay-doi-ky-thanh-toan`, {
      ChoVayId: choVayId,
      NgayThucHien: NgayThucHien,
      CountTypePaid: CountTypePaid,
      GhiChu: GhiChu,
    }),

  deleteVayThem: ({ choVayId, thuchiId }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/xoa-vay-them?chovayId=${choVayId}&thuchiId=${thuchiId}`,
      {}
    ),
  getTatToan: ({ choVayId, ngaythanhtoan }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/kiem-tra-ngay-tat-toan?chovayId=${choVayId}&ngayTatToan=${ngaythanhtoan}`,
      {}
    ),
  tatToan: ({
    choVayId,
    TenKhachHang,
    NgayThucHien,
    SoTien,
    PhiKhac,
    GhiChu,
    PhiThanhToanSom,
    KenhThanhToan,
    PhiKho,
    PhiPhatDongLai,
    PhiPhatTatToan,
    PhiPhatTatToanQuaHan,
    PhiDongLaiCham,
  }) =>
    API_AUTH.post(`quan-ly-cho-vay/luu-tat-toan`, {
      ChoVayId: choVayId,
      NgayTatToan: NgayThucHien,
      PhiKho: PhiKho,
      KenhThanhToan: KenhThanhToan,
      PhiThanhToanSom: PhiThanhToanSom,
      TienTatToan: SoTien,
      TenNguoiThanhToan: TenKhachHang,
      PhiKhac: PhiKhac,
      GhiChu: GhiChu,
      PhiPhatDongLai,
      PhiPhatTatToan,
      PhiPhatTatToanQuaHan,
      PhiDongLaiCham,
    }),
  tatToanChoDuyet: ({
    choVayId,
    TenKhachHang,
    NgayThucHien,
    SoTien,
    PhiKhac,
    GhiChu,
    PhiThanhToanSom,
    KenhThanhToan,
    PhiKho,
    PhiPhatDongLai,
    PhiPhatTatToan,
    PhiPhatTatToanQuaHan,
  }) =>
    API_AUTH.post(`quan-ly-cho-vay/luu-tat-toan-cho-duyet`, {
      ChoVayId: choVayId,
      NgayTatToan: NgayThucHien,
      PhiKho: PhiKho,
      KenhThanhToan: KenhThanhToan,
      PhiThanhToanSom: PhiThanhToanSom,
      TienTatToan: SoTien,
      TenNguoiThanhToan: TenKhachHang,
      PhiKhac: PhiKhac,
      GhiChu: GhiChu,
      PhiPhatDongLai,
      PhiPhatTatToan,
      PhiPhatTatToanQuaHan,
    }),
  deleteGiaHan: (chovayid, giaHanId ) =>
    API_AUTH.post(
      `quan-ly-cho-vay/xoa-gia-han?chovayId=${chovayid}&giaHanId=${giaHanId}`,
      {}
    ),
};

export default QuanLyChoVayApi;
